import { bootstrapApplication } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

async function bootstrap(): Promise<void> {
  // Register jeep-sqlite web component for SQLite on web/PWA
  // Skip on web dev server — WASM compatibility issues with Vite.
  // SQLite only works reliably on native (Capacitor Android/iOS).
  if (Capacitor.getPlatform() === 'web' && Capacitor.isNativePlatform()) {
    try {
      const { defineCustomElements } = await import('jeep-sqlite/loader');
      defineCustomElements(window);
      await customElements.whenDefined('jeep-sqlite');
    } catch (err) {
      console.warn('[main] Could not register jeep-sqlite for web — SQLite will be unavailable:', err);
    }
  }

  await bootstrapApplication(AppComponent, appConfig);
}

bootstrap().catch((err) => console.error(err));
